var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnnouncement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 13.333a5.334 5.334 0 0 0-4-5.146V5.333a1.333 1.333 0 0 0-1.787-1.253l-11.64 4.227L5.413 8a1.333 1.333 0 0 0-1 .36A1.333 1.333 0 0 0 4 9.333v9.334a1.333 1.333 0 0 0 1.493 1.32l1.747-.214 1.253 7.12A1.333 1.333 0 0 0 9.827 28h4.84A1.334 1.334 0 0 0 16 26.453l-.987-5.866 7.294 2.08c.119.02.24.02.36 0A1.333 1.333 0 0 0 24 21.333V18.48a5.333 5.333 0 0 0 4-5.147zM6.667 10.747l2.666.146v5.934l-2.666.333v-6.413zm6.426 14.586h-2.16l-1.04-5.893.68-.08 1.6.44.92 5.533zm8.24-5.76-7.266-2.013a1.333 1.333 0 0 0-.734-.227L12 16.96v-6.293l9.333-3.387v12.293zm2.667-4V11.04a2.667 2.667 0 0 1 0 4.587v-.054z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncement);
export default __webpack_public_path__ + "static/media/announcement.b061a8452ec405ffacf274d4077a86a0.svg";
export { ForwardRef as ReactComponent };